import moment from "moment-timezone";

export const calculateTimePassed = (timeStamp) => {
  const start = moment.utc(timeStamp);
  let timePassed = moment().diff(start, "minutes");

  if (timePassed < 60) return `${timePassed} ש׳`;

  timePassed = Math.round(timePassed / 60);
  if (timePassed < 24) return `${timePassed} שע׳`;

  timePassed = Math.round(timePassed / 24);
  if (timePassed === 1) return `לפני יום`;
  if (timePassed === 2) return `לפני יומים`;
  if (timePassed < 30) return `לפני ${timePassed} ימים`;

  timePassed = Math.round(timePassed / 30);
  if (timePassed === 1) return `לפני חודש`;
  if (timePassed === 2) return `לפני חודשיים`;
  if (timePassed < 12) return `לפני ${timePassed} חודש`;

  timePassed = Math.round(timePassed / 12);
  return `${timePassed} Year${timePassed > 1 ? "s" : ""} ago`;
};
